module.exports = require('./dist/react-data-grid');


//////////////////
// WEBPACK FOOTER
// ./~/react-data-grid/index.js
// module id = 798
// module chunks = 0